import { render, staticRenderFns } from "./_workFloGeneralInbound.vue?vue&type=template&id=69a48b44&scoped=true&"
import script from "./_workFloGeneralInbound.vue?vue&type=script&lang=js&"
export * from "./_workFloGeneralInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a48b44",
  null
  
)

export default component.exports